export const PAPS_TEMPLATE_ID = 1596565;

export const activities = [
    "Manufacturing",
    "Business services",
    "Information technology",
    "Health care",
    "Finance",
    "Retail",
    "Accounting and Legal",
    "Construction",
    "Repair and maintenance",
    "Media",
    "Restaurants",
    "Bars and food",
    "Services",
    "Banking/Mortage",
    "Insurance",
    "E-commerce",
    "Telecommunication",
    "Cosmetics",
  ];
  
export interface SendEmailArgs {
  toEmail: string;
  toName: string;
  Subject: string;
  fromEmail?: string;
  fromName?: string;
  TemplateID?: number;
  Variables?: Record<string, any>;
}

